import {
    PERSON_FIELDS,
    type FieldConflict,
    type PersonField
} from '@ast-data/shared';

/**
 * One question the conflict dialog asks: a label and the fields one choice
 * decides.
 *
 * Usually one field. A person is two — the name as written and the account
 * link beside it — and they must not be chosen apart: the name from this
 * device and the link from the server would name one person and credit
 * another. So a person row always carries BOTH, even when only one of them
 * conflicts: the other one merged on its own, and taking one side of the
 * conflict has to take that side's twin with it.
 */
export interface ConflictRow {
    /** The field the row is labelled after. */
    labelField: string;
    /** Every field this row's choice decides. */
    fields: string[];
    /** Set on a person row: how its name and ids are stored. */
    person?: PersonField;
}

export function conflictRows(
    entityType: string,
    conflicts: FieldConflict[]
): ConflictRow[] {
    const personFields = PERSON_FIELDS[entityType] ?? [];
    const rows: ConflictRow[] = [];
    const seen = new Set<string>();
    for (const { field } of conflicts) {
        const person = personFields.find(
            (candidate) => candidate.name === field || candidate.id === field
        );
        const labelField = person?.name ?? field;
        if (seen.has(labelField)) {
            continue;
        }
        seen.add(labelField);
        rows.push(
            person
                ? { labelField, fields: [person.name, person.id], person }
                : { labelField, fields: [field] }
        );
    }
    return rows;
}
